import type { ReportTableColumn } from '@roger/ui-components';
import { formatReportEmptyValue, REPORT_EMPTY_VALUE } from './reportDisplay';

/**
 * Sortable report column whose cell truncates to a single line and exposes the
 * full text as a tooltip. Empty values render the shared placeholder and carry
 * no tooltip, so a dash never shows a dash on hover.
 */
export function createReportTextColumn<Row>(
  id: string,
  header: string,
  accessor: keyof Row | ((row: Row) => unknown),
  minWidth: number,
  sortLabel = header
): ReportTableColumn<Row> {
  return {
    id,
    header,
    accessor,
    render: value => {
      const text = formatReportEmptyValue(value);
      return (
        <span
          className='block truncate'
          title={text === REPORT_EMPTY_VALUE ? undefined : text}
        >
          {text}
        </span>
      );
    },
    enableSorting: true,
    minWidth,
    sortLabel,
  };
}
